import React from "react";
import {
  Phone,
  Navigation,
  Share2,
  Bookmark,
  MapPin,
  Clock,
  MoreVertical,
  ChevronRight,
} from "lucide-react";

import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Footer from "../components/Footer";

const reviews = [
  {
    name: "Fatma Aksoy",
    date: "2 hafta önce",
    comment:
      "Abone Halı Yıkama’ya halılarımı ilk kez verdim. Açıkçası bu kadar temiz geleceğini düşünmemiştim. Lekeler çıkmış, halılar mis gibi kokuyordu. Teslimat da zamanında yapıldı. Cukurambar ve çevresinde gönül rahatlığıyla tavsiye ederim.",
  },
  {
    name: "Ahmet Güner",
    date: "3 hafta önce",
    comment:
      "Koltuk yıkama hizmeti aldım. Ekip hem randevu saatine uydu hem de işini çok özenli yaptı. Koltuklar yıkandıktan sonra gerçekten ferahladı. Abone Halı Yıkama işinin arkasında duran bir firma.",
  },
  {
    name: "Elif Yıldız",
    date: "1 ay önce",
    comment:
      "Yorgan ve halılarımı verdim, sonuçtan çok memnun kaldım. Paketleme temizdi, iletişimleri de gayet iyiydi. Halılarda kötü koku kalmamış, tertemiz teslim edildi.",
  },
  {
    name: "Murat Eren",
    date: "1 ay önce",
    comment:
      "Uzun zamandır kullandığımız halıları temizlettik. Özellikle çocuklu aileler için hijyen çok önemli. Gelen sonuç beklentimizin üzerindeydi. Herkese tavsiye ederim.",
  },
  {
    name: "Gülhan Demir",
    date: "1 ay önce",
    comment:
      "Telefonla iletişim kurduktan sonra aynı gün içerisinde halılarımız teslim alındı. Temizlik kalitesi ve müşteri ilgisi gerçekten çok başarılı. Bundan sonra düzenli olarak kullanacağım.",
  },
  {
    name: "Kenan Özkan",
    date: "2 ay önce",
    comment:
      "Daha önce farklı firmalarla çalıştım ancak Abone Halı Yıkama kadar özenli çalışan bir işletmeye denk gelmedim. Halılar ilk günkü canlılığına kavuştu.",
  },
  {
    name: "Aslı Korkmaz",
    date: "2 ay önce",
    comment:
      "Perde ve halı yıkama hizmeti aldım. Her iki hizmetten de çok memnun kaldım. Teslim süresi hızlıydı ve ürünler tertemiz şekilde paketlenmişti.",
  },
  {
    name: "Meryem Yılmaz",
    date: "3 ay önce",
    comment:
      "İletişimleri son derece profesyonel. Halıları teslim almadan önce bilgilendirme yaptılar, teslim sırasında da aynı özeni gösterdiler. Güvenilir bir firma.",
  },
  {
    name: "Tamer Sönmez",
    date: "3 ay önce",
    comment:
      "Özellikle açık renk halılarımızdaki zor lekelerin çıkacağını düşünmüyorduk. Sonuç görünce gerçekten şaşırdık. Fiyat performans açısından da oldukça başarılı.",
  },
  {
    name: "Cem Tuncer",
    date: "4 ay önce",
    comment:
      "Yıllardır Cukurambar bölgesinde hizmet alıyoruz. Kalitelerini hiç bozmadılar. Randevu, teslim alma ve teslim etme süreçleri oldukça düzenli ilerliyor. Kesinlikle tavsiye ederim.",
  },
];

const initialsColor = [
  "bg-pink-600",
  "bg-cyan-600",
  "bg-purple-700",
  "bg-orange-600",
  "bg-green-700",
  "bg-blue-700",
  "bg-rose-600",
  "bg-indigo-700",
  "bg-teal-700",
  "bg-amber-700",
];

const CukurambarReviews = () => {
  return (
    <>
      <section className="bg-white min-h-screen text-[#202124]">
        <div className="max-w-[430px] mx-auto bg-white">
          <div className="px-5 pt-6 pb-5 border-b border-gray-200">
            <div className="flex items-start justify-between">
              <div>
               <div className="flex items-center gap-3">
 

  <div>
    <h1 className="text-[24px] font-semibold leading-tight text-[#202124] mt-16">
      Abone Halı Yıkama
    </h1>

    <p className="text-[14px] text-[#5f6368] mt-1">
      Halı Yıkama Hizmeti
    </p>
  </div>
</div>

                <div className="mt-3 text-[17px] text-[#5f6368] leading-7">
                  <span>4,9</span>
                  <span className="text-[#fbbc04] mx-1">★</span>
                  <span className="text-[#1a73e8]">(471)</span>
                  <span> · Ankara'da bir halı temizleme hizmeti</span>
                  <span className="text-red-500"> · AÇIK</span>
                </div>
              </div>

              <MoreVertical size={26} className="text-[#5f6368] mt-2" />
            </div>

            <div className="mt-6 grid grid-cols-4 gap-2 overflow-hidden">
              <img src="/images/services/12.png" alt="" className="h-32 w-full object-cover" />
              <img src="/images/services/13.png" alt="" className="h-32 w-full object-cover" />
              <img src="/images/services/14.png" alt="" className="h-32 w-full object-cover" />
              <img src="/images/services/15.png" alt="" className="h-32 w-full object-cover" />
            </div>

            <div className="grid grid-cols-4 gap-4 mt-7 text-center">
              <a
                href="tel:05015336066"
                className="flex flex-col items-center gap-2 text-[#8ab4f8]"
              >
                <span className="w-[58px] h-[58px] rounded-full border-2 border-[#8ab4f8] flex items-center justify-center">
                  <Phone size={26} fill="#8ab4f8" />
                </span>
                <span className="text-[17px] font-medium">Ara</span>
              </a>

              <div className="flex flex-col items-center gap-2 text-[#8ab4f8]">
                <span className="w-[58px] h-[58px] rounded-full border-2 border-[#8ab4f8] flex items-center justify-center">
                  <Navigation size={26} fill="#8ab4f8" />
                </span>
                <span className="text-[17px] font-medium">Yol tarifi</span>
              </div>

              <div className="flex flex-col items-center gap-2 text-[#8ab4f8]">
                <span className="w-[58px] h-[58px] rounded-full border-2 border-[#8ab4f8] flex items-center justify-center">
                  <Share2 size={26} />
                </span>
                <span className="text-[17px] font-medium">Paylaş</span>
              </div>

              <div className="flex flex-col items-center gap-2 text-[#8ab4f8]">
                <span className="w-[58px] h-[58px] rounded-full border-2 border-[#8ab4f8] flex items-center justify-center">
                  <Bookmark size={26} />
                </span>
                <span className="text-[17px] font-medium">Kaydet</span>
              </div>
            </div>

            <div className="mt-6 border-t border-gray-200 pt-4 space-y-5">
              <div className="flex gap-4">
                <div className="w-14 h-14 rounded-2xl bg-[#eef3ff] flex items-center justify-center shrink-0">
                  <MapPin size={28} fill="#8ab4f8" className="text-[#8ab4f8]" />
                </div>

                <div className="text-[18px] leading-7">
                  Cukurambar/ Ankara
                  <div className="text-[#5f6368] text-[15px] mt-1">
                    🚆 45 dk. · 🚗 9 dk.
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-14 h-14 rounded-2xl bg-[#eef3ff] flex items-center justify-center shrink-0">
                  <Clock size={28} className="text-[#8ab4f8]" />
                </div>

                <div className="text-[18px] leading-7">
                  <span className="text-[#fbbc04]">Açık</span> · 08:00-22:00
                  <div className="text-[#5f6368] text-[15px] mt-1">
                    6 hafta önce bu işletme tarafından güncellendi
                  </div>
                </div>
              </div>

              <div
                className="flex gap-4 items-center border-t border-gray-200 pt-4 cursor-pointer"
                onClick={() => {
                  window.location.href = "tel:05015336066";
                }}
              >
                <div className="w-14 h-14 rounded-2xl bg-[#eef3ff] flex items-center justify-center shrink-0">
                  <Phone size={28} fill="#8ab4f8" className="text-[#8ab4f8]" />
                </div>

                <div className="text-[18px] flex-1">0501 533 60 66</div>
                <ChevronRight className="text-[#5f6368]" />
              </div>
            </div>
          </div>

          <div className="bg-white">
            {reviews.map((review, index) => (
              <article key={index} className="px-5 py-6 border-b border-gray-200">
                <div className="flex items-start justify-between">
                  <div className="flex gap-4">
                    <div
                      className={`w-14 h-14 rounded-full ${
                        initialsColor[index % initialsColor.length]
                      } text-white flex items-center justify-center text-2xl font-medium`}
                    >
                      {review.name.charAt(0)}
                    </div>

                    <div>
                      <h3 className="text-[20px] font-medium">{review.name}</h3>
                      <div className="text-[15px] text-[#5f6368] flex items-center gap-1 mt-1">
                        <span className="text-[#4285f4] font-bold">G</span>
                        Google yorumları
                      </div>
                    </div>
                  </div>

                  <MoreVertical size={25} className="text-[#5f6368]" />
                </div>

                <div className="mt-5 text-[16px] font-medium">
                  5/5{" "}
                  <span className="text-[#5f6368] font-normal">
                    · {review.date}
                  </span>
                  {index > 0 && (
                    <span className="ml-3 rounded-full bg-gray-100 px-3 py-1 text-[#5f6368]">
                      Yeni
                    </span>
                  )}
                </div>

                <p className="mt-5 text-[19px] leading-8 text-[#3c4043]">
                  {review.comment}
                </p>
              </article>
            ))}

            <div className="px-5 py-5">
              <button
  onClick={() =>
  alert(
    "🔒 Tüm müşteri yorumlarını görüntülemek için lütfen üye olun veya giriş yapın."
  )
}
  className="w-full rounded-full bg-gray-100 py-4 text-[18px] font-medium flex items-center justify-center gap-3"
>
  Tüm yorumları göster <ChevronRight size={24} />
</button>
            </div>
          </div>
        </div>
      </section>

      <ServicesGrid />
      <BlogList />
      <Footer />
    </>
  );
};

export default CukurambarReviews;